module.exports = __webpack_public_path__ + "static/media/group-people-community.1e4b1d57.svg";